import i18n from 'i18next';
import { initReactI18next, useTranslation as originalUseTranslation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { ui_en as uiEn, ui_ko as uiKo } from './ui';
import { schemas_en as schemaEn, schemas_ko as schemaKo } from './form-kit';

import type { TFunction } from 'i18next';

const resources = {
  en: {
    ui: uiEn,
    schemas: schemaEn,
    login: {},
    proxy: {},
    'tenure-check': {},
    register: {},
    'forgot-password': {},
    'my-page': {},
    'admin-dashboard': {},
  },
  ko: {
    ui: uiKo,
    schemas: schemaKo,
    login: {},
    proxy: {},
    'tenure-check': {},
    register: {},
    'forgot-password': {},
    'my-page': {},
    'admin-dashboard': {},
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    // 네임스페이스 설정 시 추가
    ns: ['ui', 'schemas'],
    interpolation: {
      escapeValue: false,
    },
    partialBundledLanguages: true,
    react: {
      useSuspense: true,
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

type ResourcesType = typeof resources;
type LanguageType = keyof ResourcesType;
type NamespaceType = keyof ResourcesType[LanguageType];

export function useTranslation(ns?: NamespaceType | NamespaceType[]) {
  return originalUseTranslation(ns as string | string[]);
}

// 언어 변경 함수
export const changeLanguage = (lng: LanguageType) => {
  return i18n.changeLanguage(lng);
};

// 네임스페이스 로드 함수
export const loadNamespaces = async (namespaces: string[]) => {
  return i18n.loadNamespaces(namespaces);
};

// 앱별 리소스 추가 함수
export const addResources = (resources: Record<string, Record<string, Record<string, unknown>>>) => {
  Object.entries(resources).forEach(([lang, namespaces]) => {
    Object.entries(namespaces).forEach(([ns, translations]) => {
      i18n.addResourceBundle(lang, ns, translations, true, true);
    });
  });
};

// 현재 언어 가져오기
export const getCurrentLanguage = (): LanguageType => {
  return i18n.language as LanguageType;
};

export { i18n as i18nInstance, TFunction };
